import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSentimentHighlySatisfiedFilled = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSentimentHighlySatisfiedFilled",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    fillRule: "evenodd",
    d: "M2 12a9.99 9.99 0 1 1 20 0 10 10 0 0 1-20 0m7.41-1.53-.53-.53-.53.53a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.06l.89-.88a1 1 0 0 1 1.41 0l.88.88c.29.29.29.77 0 1.06a.75.75 0 0 1-1.06 0m7.34 4.28A5.5 5.5 0 0 1 12 17.5a5.5 5.5 0 0 1-4.75-2.75.5.5 0 0 1 .44-.75h8.62a.5.5 0 0 1 .44.75m-3.22-4.28c.29.29.77.29 1.06 0l.53-.53.53.53c.29.29.77.29 1.06 0a.75.75 0 0 0 0-1.06l-.88-.88a1 1 0 0 0-1.41 0l-.88.88c-.3.29-.3.77-.01 1.06"
  })
}));
IconSentimentHighlySatisfiedFilled.displayName = 'IconSentimentHighlySatisfiedFilled';